import React from 'react';

const BackArrowSVG = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.3334 18.3332H13.0501L22.3667 9.0165L20.0001 6.6665L6.66675 19.9998L20.0001 33.3332L22.3501 30.9832L13.0501 21.6665H33.3334V18.3332Z"
      fill="black"
    />
  </svg>
);

export { BackArrowSVG };
